import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  Chip,
  Typography,
  Card,
  CardContent,
  Grid,
  CircularProgress,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { getPastDueItems } from "../../reducers/wip.reducer";

const WIPActionNeeded = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Get data from Redux
  const pastDueItems = useSelector((state) => state.wip.pastDueItems);
  const loading = useSelector((state) => state.wip.loadingPastDue);

  // Load past-due items on mount
  useEffect(() => {
    dispatch(getPastDueItems());
  }, [dispatch]);

  return (
    <Box sx={{ px: 3 }}>
      <Box sx={{ width: "100%", padding: "0px 48px", mt: 1 }}>
        <Box
          sx={{
            marginBottom: "30px",
            marginTop: "30px",
          }}
        >
          <Typography
            style={{
              fontSize: 30,
              fontWeight: 700,
            }}
          >
            Action Needed
          </Typography>
        </Box>

        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "400px",
            }}
          >
            <CircularProgress />
          </Box>
        ) : pastDueItems.length === 0 ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "400px",
            }}
          >
            <Typography variant="h6" color="text.secondary">
              No past-due items found
            </Typography>
          </Box>
        ) : (
          <Grid container spacing={2}>
            {pastDueItems.map((item) => (
              <Grid item xs={12} key={item._id}>
                <Card
                  sx={{
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    "&:hover": {
                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    },
                  }}
                >
                  <CardContent>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: 2,
                      }}
                    >
                      {/* Left side: Season | PO Number | Vendor Style */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                          flexWrap: "wrap",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontWeight: 600,
                            color: "#333",
                          }}
                        >
                          {item.season}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            color: "#666",
                          }}
                        >
                          |
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontWeight: 600,
                            color: "#333",
                          }}
                        >
                          {item.poNumber}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            color: "#666",
                          }}
                        >
                          |
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontWeight: 600,
                            color: "#333",
                          }}
                        >
                          {item.vendorStyle}
                        </Typography>
                      </Box>

                      {/* Right side: Past Due Substages Chips */}
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 1,
                          alignItems: "center",
                        }}
                      >
                        {item.pastDueSubstages?.map((substage, idx) => {
                          const chipLabel = `${substage.stageDisplayName}: ${substage.substageKey}: ${substage.daysPastDue}`;
                          return (
                            <Chip
                              key={idx}
                              label={chipLabel}
                              size="small"
                              sx={{
                                backgroundColor:
                                  substage.daysPastDue > 5
                                    ? "#DC2626"
                                    : substage.daysPastDue > 2
                                    ? "#F59E0B"
                                    : "#F97316",
                                color: "#fff",
                                fontWeight: 600,
                                fontSize: "12px",
                                height: "28px",
                              }}
                            />
                          );
                        })}
                        <Button
                          variant="outlined"
                          size="small"
                          endIcon={<ArrowForwardIcon />}
                          onClick={() => navigate(`/wip/${item._id}`)}
                          sx={{
                            textTransform: "none",
                            fontSize: "12px",
                            borderRadius: "8px",
                            borderColor: "#4B68D4",
                            color: "#4B68D4",
                            ml: 1,
                            "&:hover": {
                              backgroundColor: "#4B68D4",
                              color: "#fff",
                            },
                          }}
                        >
                          View
                        </Button>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </Box>
  );
};

export default WIPActionNeeded;
